module.exports = function (wowCurrencyFilter) {
    /**
     * Augments the Woolworths currency filter to display amounts under $1 formatted as cents (e.g. 50c).
     *
     * @param {Number} amount
     * @param {String} [symbol='$']
     * @param {String} [centsSymbol='¢']
     */
    return function (amount, symbol = '$', centsSymbol = '¢') {
        const amountInCents = Math.round(amount * 100);

        if (amountInCents < 100 && amountInCents !== 0) {
            return `${amountInCents}${centsSymbol}`;
        }

        return wowCurrencyFilter(amount, symbol);
    };
};



// WEBPACK FOOTER //
// ./src/common/filters/wow-currency-cents.js